// ─── SkeletonGrid / SkeletonBlock ───────────────────────────────────────────
// Grey placeholder shapes shown while a grid of photos or cards loads. They
// have the same size and spacing as the real cards, so the page doesn't jump
// when the real content arrives.
//
//   <SkeletonGrid count={6} aspectRatio="3/4" minColumnWidth={136} />
//   <SkeletonBlock width="40%" height={28} />

import Box from '@mui/material/Box';
import { BORDER } from '../../../theme/tokens2';

const shimmer = {
  background: 'linear-gradient(90deg, rgba(0,0,0,0.04) 0%, rgba(0,0,0,0.075) 50%, rgba(0,0,0,0.04) 100%)',
  backgroundSize: '200% 100%',
  '@keyframes skeletonShimmer': {
    from: { backgroundPosition: '100% 0' },
    to:   { backgroundPosition: '-100% 0' },
  },
  animation: 'skeletonShimmer 1.4s ease-in-out infinite',
  // People who turn off motion in their device settings get a still placeholder.
  '@media (prefers-reduced-motion: reduce)': { animation: 'none' },
};

export function SkeletonBlock({ width = '100%', height = 14, sx = {} }) {
  return <Box aria-hidden sx={{ width, height, borderRadius: '2px', ...shimmer, ...sx }} />;
}

export default function SkeletonGrid({ count = 4, aspectRatio = '4/5', minColumnWidth = 200, gap = '8px', label = 'Loading…' }) {
  return (
    <Box role="status" aria-label={label}>
      <Box sx={{
        display: 'grid',
        gridTemplateColumns: `repeat(auto-fill, minmax(${minColumnWidth}px, 1fr))`,
        gap,
      }}>
        {Array.from({ length: count }, (_, i) => (
          <Box key={i} aria-hidden sx={{ aspectRatio, border: `0.5px solid ${BORDER}`, borderRadius: '3px', ...shimmer }} />
        ))}
      </Box>
    </Box>
  );
}
